import React, { memo } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { ITypo } from '@/app/_components/common';
import { Icons } from '@/app/assets/Icons';
import { ROUTERS } from '@/constants';
import { map } from '@/utils';

import { Call, Clock } from 'iconsax-react';

const ctaItems = [
	{
		label: 'Liên hệ Hotline',
		href: ROUTERS.PHONE_NUMBER,
		icon: <Call size={30} color="#fff" variant="Bulk" />,
	},
	{
		label: 'Đặt lịch tư vấn',
		href: ROUTERS.ZALO,
		icon: <Clock size={30} color="#fff" variant="Bulk" />,
	},
	{
		label: 'Phản hồi nhanh Zalo',
		href: ROUTERS.ZALO,
		icon: (
			<div className="relative size-[30px]">
				<Image src={Icons.common.zalo} fill alt="DLA Viet Nam" />
			</div>
		),
	},
];

const FloatingCTA = () => {
	return (
		<div className="group fixed bottom-[50px] right-0 z-[999] space-y-3 max-sm:hidden">
			{map(ctaItems, (item, idx) => {
				const Icon = item.icon;
				return (
					<Link
						href={item.href}
						key={idx}
						className="row bg-bittersweet shadow-2 gap-2.5 rounded-l-xl border border-white p-4 pr-6 transition-all duration-500 w-[64px] group-hover:w-auto group-hover:rounded-l-3xl"
					>
						<div className="row gap-4">
							<div>{Icon}</div>
							<div className="overflow-hidden transition-all duration-500 hidden group-hover:block">
								<ITypo
									size={14}
									weight="semi"
									as="p"
									className="text-center text-white"
								>
									{item.label}
								</ITypo>
							</div>
						</div>
					</Link>
				);
			})}
		</div>
	);
};

export default memo(FloatingCTA);
